<template>
  <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="min-width: 440px; max-width: 560px; border-radius: 14px;">
      <q-card-section class="row items-center q-pb-none">
        <q-icon name="lock" color="red-7" size="26px" class="q-mr-sm" />
        <span class="dlg-title">Изменение сметы</span>
        <q-space />
        <q-btn icon="close" flat round dense v-close-popup />
      </q-card-section>

      <q-card-section>
        <div class="dlg-work-name">{{ data?.workName || '—' }}</div>

        <div class="dlg-status-row">
          <q-chip
            :color="isAdded ? 'green-2' : 'orange-2'"
            :text-color="isAdded ? 'green-9' : 'orange-9'"
            dense
            class="dlg-status-chip"
          >
            <q-icon :name="isAdded ? 'add_circle' : 'edit'" size="14px" class="q-mr-xs" />
            {{ isAdded ? 'Новая работа' : 'Изменение сметы' }}
          </q-chip>
          <span v-if="info?.rowversion" class="dlg-date">{{ fmtDateTimeRu(info.rowversion) }}</span>
        </div>

        <table class="dlg-table">
          <thead>
            <tr>
              <th></th>
              <th>Было</th>
              <th>Стало</th>
              <th>Δ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="info?.old_price != null || info?.new_price != null">
              <td class="dlg-table__label">Цена (₸)</td>
              <td class="dlg-table__old">{{ fmt(info.old_price) }}</td>
              <td class="dlg-table__new">{{ fmt(info.new_price) }}</td>
              <td :class="deltaClass(info.new_price, info.old_price)">
                {{ fmtDelta(info.new_price, info.old_price) }}
              </td>
            </tr>
            <tr v-if="info?.old_amount != null || info?.new_amount != null">
              <td class="dlg-table__label">Объём</td>
              <td class="dlg-table__old">{{ fmt(info.old_amount) }}</td>
              <td class="dlg-table__new">{{ fmt(info.new_amount) }}</td>
              <td :class="deltaClass(info.new_amount, info.old_amount)">
                {{ fmtDelta(info.new_amount, info.old_amount) }}
              </td>
            </tr>
            <tr v-if="info?.old_total_sum != null || info?.new_total_sum != null">
              <td class="dlg-table__label">Сумма (₸)</td>
              <td class="dlg-table__old">{{ fmt(info.old_total_sum) }}</td>
              <td class="dlg-table__new">{{ fmt(info.new_total_sum) }}</td>
              <td :class="deltaClass(info.new_total_sum, info.old_total_sum)">
                {{ fmtDelta(info.new_total_sum, info.old_total_sum) }}
              </td>
            </tr>
          </tbody>
        </table>

        <div class="dlg-note">
          <q-icon name="info" size="14px" color="blue-grey-4" class="q-mr-xs" />
          Ввод оперативного факта заблокирован до подписания дополнительного соглашения (ДС).
        </div>
      </q-card-section>

      <q-card-actions align="right" class="q-pt-none q-pb-md q-px-md">
        <q-btn label="Закрыть" flat no-caps color="grey-7" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { useFormatters } from '../composables/useFormatters';

const numFmt = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 });

export default {
  name: 'PpmSmetaChangeDialog',
  props: {
    modelValue: Boolean,
    data: { type: Object, default: () => ({}) },
  },
  emits: ['update:modelValue'],
  setup() {
    const { fmtDateTimeRu } = useFormatters();
    return { fmtDateTimeRu };
  },
  computed: {
    info() { return this.data?.info || {}; },
    isAdded() { return this.info.status_code === 'added'; },
  },
  methods: {
    fmt(v) {
      if (v == null) return '—';
      return numFmt.format(v);
    },
    fmtDelta(newVal, oldVal) {
      if (newVal == null || oldVal == null) return '—';
      const d = newVal - oldVal;
      const s = numFmt.format(Math.abs(d));
      if (d > 0) return '+' + s;
      if (d < 0) return '−' + s;
      return '0';
    },
    deltaClass(newVal, oldVal) {
      if (newVal == null || oldVal == null) return 'dlg-table__delta';
      const d = newVal - oldVal;
      if (d > 0) return 'dlg-table__delta dlg-table__delta--up';
      if (d < 0) return 'dlg-table__delta dlg-table__delta--down';
      return 'dlg-table__delta';
    },
  },
};
</script>

<style scoped>
.dlg-title { font-size: 15px; font-weight: 700; color: #2c3e50; }
.dlg-work-name {
  font-size: 13px; font-weight: 600; color: #334155;
  margin-bottom: 10px; line-height: 1.35;
}
.dlg-status-row {
  display: flex; align-items: center; gap: 10px; margin-bottom: 14px;
}
.dlg-status-chip { font-size: 11px; font-weight: 700; }
.dlg-date { font-size: 11px; color: #94a3b8; }

.dlg-table {
  width: 100%; border-collapse: collapse; margin-bottom: 14px;
  font-size: 13px;
}
.dlg-table th {
  text-align: right; font-weight: 600; color: #64748b;
  padding: 6px 10px; border-bottom: 2px solid #e2e8f0;
  font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;
}
.dlg-table th:first-child { text-align: left; }
.dlg-table td { padding: 8px 10px; border-bottom: 1px solid #f1f5f9; text-align: right; }
.dlg-table__label { text-align: left; font-weight: 500; color: #475569; }
.dlg-table__old { color: #94a3b8; }
.dlg-table__new { font-weight: 600; color: #1e293b; }
.dlg-table__delta { font-weight: 600; color: #64748b; font-size: 12px; }
.dlg-table__delta--up { color: #dc2626; }
.dlg-table__delta--down { color: #16a34a; }

.dlg-note {
  display: flex; align-items: flex-start;
  font-size: 12px; color: #64748b; line-height: 1.4;
  background: #f8fafc; border-radius: 8px; padding: 10px 12px;
}
</style>
